// src/utils/axios.js
import axios from 'axios';

// 创建 Axios 实例
const axiosInstance = axios.create({
  baseURL: 'https://73946ba450ka.vicp.fun',  // 后端接口地址
  headers: {
    'Content-Type': 'application/json' // 设置请求头为 JSON 格式
  }
});

// 请求拦截器：添加 token 到请求头
axiosInstance.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');  // 从 localStorage 获取 token
    console.log('axios token',token)
    if (token) {
      console.log('添加头')
      config.headers['Authorization'] = `${token}`;  // 添加 Authorization 头
    }
    
    // 打印请求头信息
    console.log('请求头信息:', config.headers);
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 响应拦截器：处理响应错误
axiosInstance.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    const { status } = error.response;
    if (status === 401) { // 401 表示未授权
      // 提示登录失效
      alert('登录失效，请重新进入应用');
      // 清除 token
      localStorage.removeItem('token');
    } else {
      // 其他错误处理
      alert('请求失败，请稍后重试');
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
